import type { ActionFunctionArgs } from '~/types/route-args';

import { verifyEmailLoginCodeAction } from '~/modules/user/email-login/email-login-landing.server';

export const VERIFY_EMAIL_LOGIN_CODE_API_ROUTE =
    '/remix-api/user/verify-email-login-code';

export const action = (args: ActionFunctionArgs) =>
    verifyEmailLoginCodeAction(args);

export type VerifyEmailLoginCodeAction =
    | {
          ok: true;
          sessionEstablished: boolean;
          /** Tracked-guest id for the `user_login` event; see the login action. */
          trackedGuestID?: number;
      }
    | { ok: false; message: string };
